import { Box } from '@mui/material';
import { titleCase } from 'title-case';

const ImageMarker: React.FC<{
  src: string;
  name: string;
  showOutline?: boolean;
  heading?: number;
  title?: string;
}> = ({ src, name, showOutline, heading = 0, title }) => {
  return (
    <Box>
      <img
        src={src}
        alt={name}
        title={
          title ? `${titleCase(name)} - ${title}` : name ? titleCase(name) : ''
        }
        style={{
          width: '30px',
          height: '30px',
          border: showOutline ? '2px solid gray' : 'none',
          borderRadius: '50%',
          transform: `rotate(${heading}deg)`,
          transformOrigin: 'center center',
        }}
      />
    </Box>
  );
};

export default ImageMarker;
